import { sendVerificationEmail } from "../../redux/admin-slices/specialist.slice";
import { hideDialog } from "../../redux/guest-slices/other.slice";
import { useDispatch, useSelector } from "react-redux";
import Icons from "../../assets/js/Icons";
import { useState } from "react";

import {
  Button, DialogActions, DialogContent, DialogTitle,
  IconButton, Stack, TextField, Typography,
} from "@mui/material";

function Askverification() {
  const dispatch = useDispatch();
  const [details, setDetails] = useState("");
  const dialogData = useSelector((state) => state.otherSlice.data);
  const email = dialogData?.email || "";
  const username = dialogData?.username || "";

  const handleClose = () => {
    dispatch(hideDialog());
  };

  const handleSubmit = (e) => {
    dispatch(sendVerificationEmail({ details, email, username }));

    handleClose();
  };
  return (
    <>
      <DialogTitle>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          Ask for Verification
          <IconButton onClick={handleClose} style={{ float: "right" }}>
            <Icons.CancelSolid />
          </IconButton>
        </Stack>
      </DialogTitle>
      {dialogData?.isEmailVerified === false ? (
        <>
          {" "}
          <DialogContent>
            <Stack spacing={2} mt={2}>
              <TextField
                label="Details"
                multiline
                rows={4}
                value={details}
                onChange={(e) => setDetails(e.target.value)}
                required
                fullWidth
                variant="outlined"
              />
            </Stack>
          </DialogContent>
          <DialogActions>
            <Button variant="contained" onClick={() => handleSubmit()}>
              Send
            </Button>
            <Button variant="outlined" onClick={handleClose}>
              Close
            </Button>
          </DialogActions>
        </>
      ) : (
        <>
          <DialogContent>
            <Typography>User already verified</Typography>
          </DialogContent>
        </>
      )}
    </>
  );
}

export default Askverification;
